module.exports = __webpack_public_path__ + "img/Mask4.ead654e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/AISmart/Mask4.png
// module id = lkkk
// module chunks = 149